import React from 'react';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { Navigate } from 'react-router';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';

export default class ContractPerformanceReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null,
            records: [],
            fromDate: null,
            toDate: null,
            expandedContractId: null
        };
    }

    componentDidMount() {
        this.httpPost('api/v1/common/get', {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({ data: data, loading: false });
                }
            });
    }

    toISODate(dateObj) {
        if (!dateObj) return null;
        return dateObj.toDate().toISOString();
    }

    loadReport = () => {
        this.setState({ loading: true, expandedContractId: null });
        this.httpPost('api/v1/report/contract-performance', {
            fromDate: this.toISODate(this.state.fromDate),
            toDate: this.toISODate(this.state.toDate)
        }).then(data => {
            if (data.status === 1) {
                this.setState({ records: data.records, loading: false, data });
            } else {
                this.showErorrMessage(data.message);
                this.setState({ loading: false });
            }
        });
    };

    toggleContract = (contractId) => {
        this.setState(prev => ({
            expandedContractId: prev.expandedContractId === contractId ? null : contractId
        }));
    };

    // ===================== Excel Export =====================
    exportExcel = () => {
        const { records } = this.state;
        if (!records.length) {
            this.showErorrMessage('داده‌ای برای خروجی وجود ندارد');
            return;
        }

        let html = `
            <html xmlns:o="urn:schemas-microsoft-com:office:office"
                  xmlns:x="urn:schemas-microsoft-com:office:excel"
                  xmlns="http://www.w3.org/TR/REC-html40">
            <head>
                <meta charset="UTF-8">
                <title>گزارش عملکرد قراردادها</title>
            </head>
            <body>
            <table border="1">
                <tr>
                    <th>شماره قرارداد</th>
                    <th>مشتری</th>
                    <th>کل وظایف</th>
                    <th>تکمیل‌شده</th>
                    <th>در حال انجام</th>
                    <th>عنوان وظیفه</th>
                    <th>مجری</th>
                    <th>وضعیت</th>
                    <th>مدت زمان</th>
                    <th>شرح وظیفه</th>
                </tr>`;

        records.forEach(c => {
            c.tasks.forEach(t => {
                html += `<tr>
                    <td>${c.contractNumber || ''}</td>
                    <td>${c.customerName || ''}</td>
                    <td>${c.totalTasks}</td>
                    <td>${c.completedTasks}</td>
                    <td>${c.inProgressTasks}</td>
                    <td>${t.title || ''}</td>
                    <td>${t.assignedTo || ''}</td>
                    <td>${t.statusText || ''}</td>
                    <td>${t.duration || ''}</td>
                    <td>${(t.description || '').replace(/<[^>]*>/g, '')}</td>
                </tr>`;
            });
        });

        html += `</table></body></html>`;

        const blob = new Blob(['\ufeff' + html], {
            type: 'application/vnd.ms-excel;charset=utf-8;'
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'contract-performance.xls';
        link.click();
        URL.revokeObjectURL(link.href);
    };

    // ===================== Print =====================
    printReport = () => {
        const { records } = this.state;
        let html = `<html><head><title>گزارش عملکرد قراردادها</title>
            <style>
                body { font-family: Tahoma, sans-serif; direction: rtl; padding: 20px; font-size: 9pt; }
                table { width: 100%; border-collapse: collapse; margin-top: 10px; }
                th, td { border: 1px solid #000; padding: 5px 8px; text-align: center; }
                th { background: #eee; }
                h2, h3 { text-align: center; }
                .sub-table { width: 95%; margin: 10px auto; }
            </style></head><body>
            <h2>گزارش عملکرد قراردادها</h2>`;

        records.forEach(c => {
            html += `<h3>${c.contractNumber} – ${c.customerName}</h3>
            <p>کل وظایف: ${c.totalTasks} | تکمیل‌شده: ${c.completedTasks} | در حال انجام: ${c.inProgressTasks}</p>
            <table class="sub-table">
                <tr><th>عنوان وظیفه</th><th>مجری</th><th>وضعیت</th><th>مدت زمان</th></tr>`;
            c.tasks.forEach(t => {
                html += `<tr><td>${t.title}</td><td>${t.assignedTo}</td><td>${t.statusText}</td><td>${t.duration}</td></tr>`;
            });
            html += `</table>`;
        });
        html += `</body></html>`;
        const win = window.open('', '_blank');
        win.document.write(html);
        win.document.close();
        setTimeout(() => win.print(), 300);
    };

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        const { loading, records, fromDate, toDate, expandedContractId } = this.state;

        let contents = this.state.loading ? this.renderLoading() : [
            this.state.lockScreen === 1 && this.lockScreen(),
            <Header data={this.state.data} />,
            <div className="nk-content" key="content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="page-title">گزارش عملکرد قراردادها</h3>
                                    </div>
                                    {records.length > 0 && (
                                        <div className="nk-block-head-content d-flex">
                                            <button className="btn btn-outline-info" onClick={this.printReport}>
                                                <em className="icon ni ni-printer"></em> چاپ
                                            </button>
                                            <button className="btn btn-outline-success" onClick={this.exportExcel}>
                                                <em className="icon ni ni-file-xls"></em> خروجی Excel
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="card card-bordered mb-3">
                                <div className="card-inner">
                                    <div className="row g-3 align-items-end">
                                        <div className="col-md-2">
                                            <label className="form-label">از تاریخ</label>
                                            <DatePicker calendar={persian} locale={persian_fa}
                                                value={fromDate} onChange={d => this.setState({ fromDate: d })}
                                                format="YYYY/MM/DD" inputClass="form-control" />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">تا تاریخ</label>
                                            <DatePicker calendar={persian} locale={persian_fa}
                                                value={toDate} onChange={d => this.setState({ toDate: d })}
                                                format="YYYY/MM/DD" inputClass="form-control" />
                                        </div>
                                        <div className="col-md-2">
                                            <button className="btn btn-primary" onClick={this.loadReport}>دریافت گزارش</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-bordered card-stretch">
                                {loading ? this.renderLoading() : (
                                    records.length > 0 ? (
                                        <div className="card-inner p-0">
                                            <table className="table table-bordered table-responsive">
                                                <thead>
                                                    <tr>
                                                        <th>ردیف</th>
                                                        <th>شماره قرارداد</th>
                                                        <th>مشتری</th>
                                                        <th>کل وظایف</th>
                                                        <th>تکمیل‌شده</th>
                                                        <th>در حال انجام</th>
                                                        <th>جزئیات</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {records.map((c, idx) => (
                                                        <React.Fragment key={c.contractId}>
                                                            <tr onClick={() => this.toggleContract(c.contractId)} style={{ cursor: 'pointer' }}>
                                                                <td>{idx + 1}</td>
                                                                <td>{c.contractNumber}</td>
                                                                <td>{c.customerName}</td>
                                                                <td>{c.totalTasks}</td>
                                                                <td>{c.completedTasks}</td>
                                                                <td>{c.inProgressTasks}</td>
                                                                <td>
                                                                    <button className="btn btn-sm btn-light">
                                                                        {expandedContractId === c.contractId ? 'بستن' : 'مشاهده'}
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            {expandedContractId === c.contractId && (
                                                                <tr>
                                                                    <td colSpan="7">
                                                                        <div className="p-3">
                                                                            <h6>لیست وظایف</h6>
                                                                            <table className="table table-sm table-bordered">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>عنوان وظیفه</th>
                                                                                        <th>شرح</th>
                                                                                        <th>مجری</th>
                                                                                        <th>وضعیت</th>
                                                                                        <th>مدت زمان</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {c.tasks.map(t => (
                                                                                        <tr key={t.id}>
                                                                                            <td>{t.title}</td>
                                                                                            <td>{t.description || '---'}</td>
                                                                                            <td>{t.assignedTo}</td>
                                                                                            <td>{t.statusText}</td>
                                                                                            <td>{t.duration}</td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="card-inner"><div className="alert alert-info">داده‌ای یافت نشد.</div></div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <Footer key="footer" />
        ];

        return contents;
    }
}